export const routes = [
    {
        context: 'engagement',
        method: 'GET',
        path: '/consent',
        operationId: 'Consent_list',
        auth: 'tenant',
        action: 'consent:list',
        tool: 'engagement_Consent_list',
        description: "The tenant's consent ledger: the current state per subject and channel.",
        pathParams: [],
        queryParams: ['cursor', 'limit', 'subject'],
        hasBody: false,
        successStatus: 200,
    },
    {
        context: 'engagement',
        method: 'POST',
        path: '/consent',
        operationId: 'Consent_add',
        auth: 'tenant',
        action: 'consent:record',
        tool: 'engagement_Consent_add',
        description: 'Record an opt-in or opt-out by hand (a verbal request, a written one). Appends to the history.',
        pathParams: [],
        queryParams: [],
        hasBody: true,
        successStatus: 201,
    },
    {
        context: 'engagement',
        method: 'GET',
        path: '/devices',
        operationId: 'Devices_list',
        auth: 'tenant',
        action: 'device:list',
        tool: 'engagement_Devices_list',
        description: "The caller's phones registered for push notifications in this workspace.",
        pathParams: [],
        queryParams: ['cursor', 'limit'],
        hasBody: false,
        successStatus: 200,
    },
    {
        context: 'engagement',
        method: 'POST',
        path: '/devices',
        operationId: 'Devices_register',
        auth: 'tenant',
        action: 'device:register',
        assistantExempt: 'a phone registers itself with the token its operating system issued',
        description: "Register the caller's phone for push. The same token again is the same device, refreshed.",
        pathParams: [],
        queryParams: [],
        hasBody: true,
        successStatus: 201,
    },
    {
        context: 'engagement',
        method: 'DELETE',
        path: '/devices/{deviceId}',
        operationId: 'Devices_remove',
        auth: 'tenant',
        action: 'device:remove',
        tool: 'engagement_Devices_remove',
        description: "Stop push notifications to one of the caller's phones.",
        pathParams: ['deviceId'],
        queryParams: [],
        hasBody: false,
        successStatus: 204,
    },
    {
        context: 'engagement',
        method: 'GET',
        path: '/notices',
        operationId: 'Notices_list',
        auth: 'tenant',
        action: 'notice:list',
        tool: 'engagement_Notices_list',
        description: "The caller's current notices, newest first: not withdrawn, not expired; acknowledged ones included.",
        pathParams: [],
        queryParams: [],
        hasBody: false,
        successStatus: 200,
    },
    {
        context: 'engagement',
        method: 'POST',
        path: '/notices/{noticeId}/acknowledge',
        operationId: 'Notices_acknowledge',
        auth: 'tenant',
        action: 'notice:acknowledge',
        assistantExempt: 'a person tells us they have read a notice; no model does that for them',
        description: 'The caller acknowledges one notice as themselves. Idempotent: the first time is kept.',
        pathParams: ['noticeId'],
        queryParams: [],
        hasBody: false,
        successStatus: 200,
    },
    {
        context: 'engagement',
        method: 'GET',
        path: '/notifications',
        operationId: 'Notifications_list',
        auth: 'tenant',
        action: 'notification:list',
        tool: 'engagement_Notifications_list',
        description: "Messages engagement delivered (or tried to) for the caller's tenant, newest first.",
        pathParams: [],
        queryParams: ['cursor', 'limit', 'since', 'status', 'template'],
        hasBody: false,
        successStatus: 200,
    },
    {
        context: 'engagement',
        method: 'GET',
        path: '/notifications/{notificationId}',
        operationId: 'Notifications_get',
        auth: 'tenant',
        action: 'notification:read',
        tool: 'engagement_Notifications_get',
        description: 'One message and its delivery state.',
        pathParams: ['notificationId'],
        queryParams: [],
        hasBody: false,
        successStatus: 200,
    },
    {
        context: 'engagement',
        method: 'GET',
        path: '/preferences',
        operationId: 'Preferences_get',
        auth: 'tenant',
        action: 'preference:read',
        tool: 'engagement_Preferences_get',
        description: "The caller's notification preferences in this workspace.",
        pathParams: [],
        queryParams: [],
        hasBody: false,
        successStatus: 200,
    },
    {
        context: 'engagement',
        method: 'PUT',
        path: '/preferences',
        operationId: 'Preferences_update',
        auth: 'tenant',
        action: 'preference:update',
        tool: 'engagement_Preferences_update',
        description: 'Turn push notifications on or off for the caller in this workspace.',
        pathParams: [],
        queryParams: [],
        hasBody: true,
        successStatus: 200,
    },
];
//# sourceMappingURL=routes.js.map